import {Component, Input, TemplateRef, HostListener, Inject, ViewEncapsulation} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IAlertDialogData } from '@irb/app.model';
import {DomSanitizer} from '@angular/platform-browser';

@Component({ standalone: false,
  selector: 'irb-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss', '../../styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmationDialogComponent {
  dTitle: string;
  dProceedBtnLabel: string;
  dCancelBtnLabel: string;
  onProceed: Function;
  onCancel: Function;
  dType: string;
  msg: string;
  altMsg: string;
  altMsgHTML: any; //deprecated, use altMsgTemplate instead
  @Input() altMsgTemplate: TemplateRef<any>;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>, @Inject(MAT_DIALOG_DATA) public mdd: IAlertDialogData, private sanitizer: DomSanitizer) {
    this.dTitle = this.mdd.dTitle || "Confirm";
    this.dProceedBtnLabel = this.mdd.dProceedBtnLabel || "Continue";
    this.dCancelBtnLabel = this.mdd.dCancelBtnLabel || "Close";
    this.onProceed = this.mdd.onProceed || null;
    this.onCancel = this.mdd.onCancel || null;
    this.dType = this.mdd.dType || "NONE";
    this.msg = this.mdd.msg || null;
    this.altMsg = this.mdd.altMsg || null;
    this.altMsgHTML = this.mdd.altMsgHTML || null;
    this.altMsgTemplate = this.mdd.altMsgTemplate || null;
    
    if (this.altMsgHTML) {
      this.altMsgHTML = sanitizer.bypassSecurityTrustHtml(this.altMsgHTML);
    }
  }

  close() {
    this.cancel();
  }

  continue() {
    if(this.onProceed) {
      this.onProceed();
    }

    this.dialogRef.close();
  }

  cancel() {
    if(this.onCancel) {
      this.onCancel();
    }

    this.dialogRef.close();
  }
  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    const ESCAPE_KEYCODE = 27;
    const ENTER_KEYCODE = 13;
    if (event.key === 'Escape' || event.keyCode === ESCAPE_KEYCODE) {
      this.close();
    } else if (event.key === 'Enter' || event.keyCode === ENTER_KEYCODE) {
      this.continue();
    }
  }
}
